//LIST_EDUCATION
export const listEducation = (
   education = []     
) => ({
    type: 'LIST_EDUCATION',
    education
});




// WEBPACK FOOTER //
// ./src/actions/education.js